module.exports = __webpack_public_path__ + "src/img/more/ghisleri.fb9f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/more/ghisleri.jpg
// module id = 112
// module chunks = 0